const companyInfo = {
    phoneNumber: "+381 62 8597086",
    emailAddress: "contact@isl-technologies.com",
    officeAddress: "Janka Veselinovića 44 Novi Sad",
    social:{
        linkedin: "https://www.linkedin.com/company/isl-tech"
    }

}
export default companyInfo